// @flow
import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { Day } from 'components/day'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'

const isMobile = browserCheck.isMobile

export class SunGrid extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {}
  }

  componentDidMount() {}

  render() {
    const monthData = [-1].concat(this.props.data) // [ 4, 3, 2, 1 ]
    let dayCount = -1
    let month = 'Juni'
    const displayData = monthData.map((value, i) => {
      dayCount++
      if (i === 31) {
        month = 'Juli'
        dayCount = 1
      } else if (i === 62) {
        month = 'August'
        dayCount = 1
      }
      return {
        percentage: value,
        day: dayCount,
        month: month
      }
    })
    //console.log('displayData:', displayData)

    return (
      <div className='sungrid'>
        <div
          className={
            isMobile ? 'ui seven column grid' : 'ui fourteen column grid'
          }
        >
          <div className='column weekday'>&nbsp;</div>
          <div className='column weekday'>Di</div>
          <div className='column weekday'>Mi</div>
          <div className='column weekday'>Do</div>
          <div className='column weekday'>Fr</div>
          <div className='column weekday'>Sa</div>
          <div className='column weekday'>So</div>
          {!isMobile && (
            <React.Fragment>
              <div className='column weekday'>Mo</div>
              <div className='column weekday'>Di</div>
              <div className='column weekday'>Mi</div>
              <div className='column weekday'>Do</div>
              <div className='column weekday'>Fr</div>
              <div className='column weekday'>Sa</div>
              <div className='column weekday'>So</div>
            </React.Fragment>
          )}
          {displayData.map((value, i) => {
            return (
              <div className='column' key={'column-' + i}>
                <Day percentage={value.percentage} month={value.month}>
                  {value.day + '.'}
                </Day>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}
